export default {
  en: {
    registrationType: {
      new: "New Diksha",
      newDescription: "I wish to receive Mantra Diksha",
      existing: "Already Received Diksha",
      existingDescription: "I am an existing disciple",
    },
    anniversary: {
      label: "Anniversary Date (Optional)",
      invalid: "Please enter a valid anniversary date",
    },
    occupation: {
      label: "Occupation",
      placeholder: "e.g. Teacher, Engineer, Homemaker",
      required: "Occupation is required",
      min: "Occupation must be at least 2 characters",
    },
    idValidation: {
      aadhaarRequired: "Aadhaar number is required for Indian nationals",
      aadhaarDocumentRequired: "Please upload your Aadhaar document",
      passportDocumentRequired: "Please upload your passport document",
    },
    camera: {
      title: "Take a Selfie",
      or: "or",
      takeSelfie: "Take a Selfie",
      retakeSelfie: "Take new selfie",
      starting: "Starting camera...",
      error: "Camera is not available. Please allow camera access in your browser, or open your phone camera below.",
      openCamera: "Open Camera",
      capture: "Capture",
      retake: "Retake",
      usePhoto: "Use Photo",
      cancel: "Cancel",
    },
    existing: {
      title: "Existing Disciple Registration",
      subtitle: "Share your diksha details with the ashram",
      section: "Your Diksha Details",
      mantraNotice:
        "Please do not write your Guru Mantra anywhere in this form. It is sacred and confidential.",
      fields: {
        dikshaYear: "Year of Diksha",
        dikshaPlace: "Place / Occasion of Diksha",
        spiritualName: "Spiritual Name Given (if any)",
        currentCity: "Current City / State",
        message: "Message",
      },
      placeholders: {
        dikshaYear: "e.g. 2019",
        dikshaPlace: "e.g. Kumbh Mela, Haridwar",
        spiritualName: "Name received at diksha",
        currentCity: "e.g. Haridwar, Uttarakhand",
        message: "Anything you would like to share with the ashram...",
      },
      validation: {
        dikshaYearRequired: "Year of diksha is required",
        dikshaYearValid: "Enter a valid year between 1950 and this year",
        dikshaPlaceRequired: "Please tell us where you received diksha",
        currentCityRequired: "Please enter your current city / state",
      },
      declaration: {
        section: "Declaration",
        title: "Existing Disciple Declaration",
        truthful: {
          title: "1. Truthful Information:",
          content:
            "I confirm that I have already received Mantra Diksha from Pujya Swami Avdheshanand Giri Ji Maharaj and that the details I have shared are true.",
        },
        confidentiality: {
          title: "2. Confidentiality:",
          content: "I will keep my Guru Mantra sacred and have not written it anywhere in this form.",
        },
        verification: {
          title: "3. Verification:",
          content: "The ashram may contact me to verify these details before updating its disciple records.",
        },
        dataUsage: {
          title: "4. Data Usage:",
          content: "Personal information will be used only for spiritual guidance and communication purposes.",
        },
        acceptance:
          "I have read and agree to the above declaration and allow the ashram to use these details to maintain disciple records and contact me.",
      },
      buttons: {
        submit: "Submit Details",
        acceptDeclaration: "Please Accept the Declaration",
        mustAccept: "You must accept the declaration before submitting your details",
      },
    },
  },
  hi: {
    registrationType: {
      new: "नई दीक्षा",
      newDescription: "मैं मंत्र दीक्षा लेना चाहता/चाहती हूँ",
      existing: "दीक्षा पहले ले चुके हैं",
      existingDescription: "मैं पहले से दीक्षित शिष्य हूँ",
    },
    anniversary: {
      label: "वर्षगांठ तिथि (वैकल्पिक)",
      invalid: "कृपया मान्य वर्षगांठ तिथि दर्ज करें",
    },
    occupation: {
      label: "व्यवसाय / पेशा",
      placeholder: "जैसे शिक्षक, इंजीनियर, गृहिणी",
      required: "व्यवसाय / पेशा आवश्यक है",
      min: "व्यवसाय / पेशा कम से कम 2 अक्षरों का होना चाहिए",
    },
    idValidation: {
      aadhaarRequired: "भारतीय नागरिकों के लिए आधार संख्या आवश्यक है",
      aadhaarDocumentRequired: "कृपया अपना आधार दस्तावेज़ अपलोड करें",
      passportDocumentRequired: "कृपया अपना पासपोर्ट दस्तावेज़ अपलोड करें",
    },
    camera: {
      title: "सेल्फ़ी लें",
      or: "या",
      takeSelfie: "सेल्फ़ी लें",
      retakeSelfie: "नई सेल्फ़ी लें",
      starting: "कैमरा शुरू हो रहा है...",
      error: "कैमरा उपलब्ध नहीं है। कृपया ब्राउज़र में कैमरा की अनुमति दें, या नीचे से फ़ोन का कैमरा खोलें।",
      openCamera: "कैमरा खोलें",
      capture: "फ़ोटो लें",
      retake: "दोबारा लें",
      usePhoto: "यह फ़ोटो उपयोग करें",
      cancel: "रद्द करें",
    },
    existing: {
      title: "दीक्षित शिष्य पंजीकरण",
      subtitle: "अपनी दीक्षा का विवरण आश्रम के साथ साझा करें",
      section: "आपकी दीक्षा का विवरण",
      mantraNotice: "कृपया इस फ़ॉर्म में कहीं भी अपना गुरु मंत्र न लिखें। यह पवित्र और गोपनीय है।",
      fields: {
        dikshaYear: "दीक्षा का वर्ष",
        dikshaPlace: "दीक्षा का स्थान / अवसर",
        spiritualName: "दिया गया आध्यात्मिक नाम (यदि कोई हो)",
        currentCity: "वर्तमान शहर / राज्य",
        message: "संदेश",
      },
      placeholders: {
        dikshaYear: "जैसे 2019",
        dikshaPlace: "जैसे कुंभ मेला, हरिद्वार",
        spiritualName: "दीक्षा में मिला नाम",
        currentCity: "जैसे हरिद्वार, उत्तराखंड",
        message: "आश्रम के साथ आप जो कुछ साझा करना चाहें...",
      },
      validation: {
        dikshaYearRequired: "दीक्षा का वर्ष आवश्यक है",
        dikshaYearValid: "1950 से इस वर्ष के बीच एक मान्य वर्ष दर्ज करें",
        dikshaPlaceRequired: "कृपया बताएं कि आपने दीक्षा कहाँ ली",
        currentCityRequired: "कृपया अपना वर्तमान शहर / राज्य दर्ज करें",
      },
      declaration: {
        section: "घोषणा",
        title: "दीक्षित शिष्य घोषणा",
        truthful: {
          title: "1. सत्य जानकारी:",
          content:
            "मैं पुष्टि करता/करती हूँ कि मैंने पूज्य स्वामी अवधेशानंद गिरि जी महाराज से मंत्र दीक्षा पहले ही प्राप्त कर ली है और मेरे द्वारा दी गई जानकारी सत्य है।",
        },
        confidentiality: {
          title: "2. गोपनीयता:",
          content: "मैं अपने गुरु मंत्र को पवित्र रखूँगा/रखूँगी और मैंने इसे इस फ़ॉर्म में कहीं नहीं लिखा है।",
        },
        verification: {
          title: "3. सत्यापन:",
          content: "आश्रम अपने शिष्य रिकॉर्ड को अपडेट करने से पहले इन विवरणों की पुष्टि के लिए मुझसे संपर्क कर सकता है।",
        },
        dataUsage: {
          title: "4. डेटा उपयोग:",
          content: "व्यक्तिगत जानकारी का उपयोग केवल आध्यात्मिक मार्गदर्शन और संचार के लिए किया जाएगा।",
        },
        acceptance:
          "मैंने उपरोक्त घोषणा पढ़ ली है, मैं इससे सहमत हूँ और आश्रम को शिष्य रिकॉर्ड रखने तथा मुझसे संपर्क करने के लिए इन विवरणों का उपयोग करने की अनुमति देता/देती हूँ।",
      },
      buttons: {
        submit: "विवरण जमा करें",
        acceptDeclaration: "कृपया घोषणा स्वीकार करें",
        mustAccept: "विवरण जमा करने से पहले आपको घोषणा स्वीकार करनी होगी",
      },
    },
  },
};
